const DownloadFileIcon = (props) => (
  <svg
    width="70"
    height="36"
    viewBox="0 0 48 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0H21L27 6H42C43.5913 6 45.1174 6.63214 46.2426 7.75736C47.3679 8.88258 48 10.4087 48 12V30C48 31.5913 47.3679 33.1174 46.2426 34.2426C45.1174 35.3679 43.5913 36 42 36H6C4.4087 36 2.88258 35.3679 1.75736 34.2426C0.632141 33.1174 0 31.5913 0 30V6Z"
      fill="#FB9318"
    />
    <path
      d="M24 27L30 21M24 15V27V15ZM24 27L18 21L24 27Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadFileIcon;
